const colors = {
  reset: '\x1b[0m',
  bold: '\x1b[1m',
  white: '\x1b[37m',
  bgRed: '\x1b[41m',
  bgGreen: '\x1b[42m',
  bgYellow: '\x1b[43m'
};

function log(message: string): void;
function log(type: 'success' | 'info' | 'error', message: string): void;

function log(
  typeOrMessage: 'success' | 'info' | 'error' | string,
  message?: string
): void {
  let type: 'success' | 'info' | 'error' | 'default' = 'default';
  if (!message) {
    message = typeOrMessage;
  } else {
    type = typeOrMessage as 'success' | 'info' | 'error';
  }

  switch (type) {
    case 'success':
      console.log(
        `${colors.bgGreen}${colors.white}${colors.bold} SUCCESS ${colors.reset} ${message}`
      );
      break;
    case 'info':
      console.log(
        `${colors.bgYellow}${colors.white}${colors.bold} INFO ${colors.reset} ${message}`
      );
      break;
    case 'error':
      console.error(
        `${colors.bgRed}${colors.white}${colors.bold} ERROR ${colors.reset} ${message}`
      );
      break;
    case 'default':
      console.log(message);
      break;
  }
}

export default log;
